import { RouterProvider } from 'react-router-dom'
import { router } from '@/presentation/routes/routes'

export const RoutesProvider = ({ ...props }) => {
  return <RouterProvider router={router} {...props} />
}
